export default {
  UPDATE_ERROR_TAB: "UPDATE_ERROR_TAB"
};
